'use strict'

class ProductFilter {
    static activeTab
    static activeProperties = []
    static sefDelFilterUrl

    static lastPosition = {}
    static filterCountMessage = ''

    static dependentProperties = {}
    static hideNotAvailableProperties = []

    /**
     * Обработка события клика по вкладкам.
     * @param tab
     */
    static openTab(tab) {
        /**
         * Скрывает все свойства
         */
        let hideProperties = document.querySelectorAll('[id^=filter_property_]')
        hideProperties.forEach(property => {
            property.style.display = 'none'
        })

        let filterList = document.querySelector('.filter__list')
        /**
         * Добавляет/убирает у вкладки класс активности.
         * Корректирует ширину вкладки, что бы жирный шрифт не увеличил ширину вкладки.
         */
        if (tab.classList.contains('filter__tab_active')) {
            tab.classList.remove('filter__tab_active')
            tab.style.maxWidth = ''
            filterList.classList.add('filter__list_hide-on-desktop')
            this.activeTab = ''
        } else {
            if (filterList.classList.contains('filter__list_hide-on-desktop')) {
                filterList.classList.remove('filter__list_hide-on-desktop')
            }
            let filterTabActive = document.querySelector('.filter__tab_active')
            if (filterTabActive) {
                filterTabActive.classList.remove('filter__tab_active')
                filterTabActive.style.maxWidth = ''
            }
            tab.style.maxWidth = tab.offsetWidth + 'px'
            tab.classList.add('filter__tab_active')


            /**
             * Показывает нужные свойства после клика по вкладке (для десктопа)
             */
            let properties = JSON.parse(tab.dataset.properties)
            if (properties) {
                properties.forEach(property => {
                    let propertyElement = document.getElementById(property)
                    if (propertyElement) {
                        propertyElement.style.display = ''
                    }
                })
            }
            this.activeTab = tab.id
        }
    }

    /**
     * Обработка события клика по вкладке свойства (используется в мобильной версии).
     * @param elementHead
     */
    static openProperty(elementHead) {
        let propertyId = elementHead.parentElement.id
        let elementBody = elementHead.nextElementSibling

        if (elementHead.classList.contains('filter__element-head_active')) {
            /**
             * Если вкладка была открыта.
             */

            elementHead.classList.remove('filter__element-head_active')
            elementBody.classList.remove('filter__element-body_active')

            /**
             * Удаляет из памяти открытую вкладку.
             */
            let i = this.activeProperties.indexOf(propertyId)
            this.activeProperties.splice(i, 1)
        } else {
            /**
             * Если вкладка не была открыта.
             */

            /**
             * Закрывает другие открытые вкладки.
             */
            this.activeProperties.forEach(function (itemPropertyId) {
                if (itemPropertyId === propertyId) {
                    return
                }
                let itemElementHead = document.querySelector('#' + itemPropertyId + ' .filter__element-head')
                this.openProperty(itemElementHead)
            }, this)

            elementHead.classList.add('filter__element-head_active')
            elementBody.classList.add('filter__element-body_active')

            /**
             * Запоминает открытую вкладку. Что бы её можно было открыть после ajax обновления.
             */
            if (!this.activeProperties.includes(propertyId)) {
                this.activeProperties.push(propertyId)
            }

            /**
             * Скролит страницу так что бы открываемая вкладка была сверху.
             */
            this.scrollTo(elementHead)
        }
    }


    static closeAllProperty() {
        this.activeProperties = []
        document.querySelectorAll('.filter__element-head_active').forEach(function (element) {
            element.classList.remove('filter__element-head_active')
            /**
             * Удаляет active из body только при наличии head,
             * так как бывают свойства как сортировка которым не нужно удалять.
             */
            let body = element.parentNode.querySelector('.filter__element-body')
            if (body) {
                body.classList.remove('filter__element-body_active')
            }
        })
    }

    static closeAllTabs() {
        this.activeTab = []
        document.querySelector('.filter__list').classList.add('filter__list_hide-on-desktop')
        /**
         * Скрывает все свойства
         */
        let hideProperties = document.querySelectorAll('[id^=filter_property_]')
        hideProperties.forEach(property => {
            property.style.display = 'none'
        })
        document.querySelectorAll('.filter__tab_active').forEach(function (element) {
            element.classList.remove('filter__tab_active')
        })
    }


    /**
     * Обработка события клика по кнопке "Показать".
     * @param button
     */
    static showProducts(button) {
        this.closeAllProperty()
        this.closeAllTabs()
        let firstCatalogElement = document.querySelector('.filter')
        if (firstCatalogElement) {
            this.scrollTo(firstCatalogElement)
        }
    }

    /**
     * Скролит страницу так что бы открываемый элемент был сверху, сразу под фиксированной шапкой.
     */
    static scrollTo(element) {
        let siteHeaderHeight = 0
        let header = document.querySelector('header.header')
        if (header) {
            siteHeaderHeight = header.getBoundingClientRect().height
        }
        let scrollY = window.scrollY + element.getBoundingClientRect().y - siteHeaderHeight
        window.scroll(0, scrollY)
    }


    /**
     * Сброс фильтра.
     */
    static clear() {
        if (this.sefDelFilterUrl) {
            window.location.href = this.sefDelFilterUrl
        }
    }

    /**
     * Обновляет список выбранных значений свойств.
     * @param checked
     */
    static updateSelectedList(checked) {
        if (checked) {
            let allSelectedLists = document.querySelectorAll('.filter__selected-list')
            allSelectedLists.forEach(function (selectedList) {
                /**
                 * Удаляет все выбранные значения свойств.
                 */
                selectedList.querySelectorAll('.filter__selected').forEach(function (select) {
                    select.remove()
                })

                let isDark = selectedList.classList.contains('filter__selected-list_dark')

                /**
                 * Добавляет новый список выбранных значений свойств.
                 */
                checked.forEach(function (element) {
                    let newElement = document.createElement('span')
                    newElement.classList.add('filter__selected')
                    if (isDark) {
                        newElement.classList.add('filter__selected_dark')
                    }
                    newElement.setAttribute('onclick', 'ProductFilter.cancelFilter(this)')
                    newElement.dataset.json = element.JSON
                    newElement.dataset.property = element.CODE
                    newElement.innerText = element.NAME

                    selectedList.append(newElement)
                })
            })
        }

        /**
         * Скрывает/показывает filter__selected-list в зависимости от наличия выбранных значений.
         */
        this.updateVisibilitySelectedList()

        /**
         * Показывает/скрывает зависимые свойства
         */
        let openProperties = []
        if (checked) {
            checked.forEach(function (element) {
                if (element.CODE in this.dependentProperties) {
                    if (!openProperties.includes(element.CODE)) {
                        openProperties.push(element.CODE)
                    } else {
                        return
                    }
                    let propertyId = 'filter_property_' + this.dependentProperties[element.CODE]
                    let property = document.getElementById(propertyId)
                    if (property) {
                        property.classList.remove('filter__element_hide')
                    }
                }
            }, this)
        }
        for (let key in this.dependentProperties) {
            if (openProperties.includes(key)) {
                continue
            }
            let dependentElementId = this.dependentProperties[key]
            let dependentElement = document.getElementById('filter_property_' + dependentElementId)
            if (dependentElement) {
                dependentElement.classList.add('filter__element_hide')
                /**
                 * Отменяет выбранные значения (если такие есть) зависимого свойства
                 */
                let cancelFilter = document.querySelector('.filter__selected[data-property="' + dependentElementId + '"]')
                if (cancelFilter) {
                    this.cancelFilter(cancelFilter)
                }
            }
        }
    }

    /**
     * Скрывает/показывает filter__selected-list в зависимости от наличия выбранных значений.
     */
    static updateVisibilitySelectedList() {
        let allSelectedLists = document.querySelectorAll('.filter__selected-list')
        let show
        allSelectedLists.forEach(function (selectedList) {
            if (typeof show === 'undefined') {
                /**
                 * > 1 так как всегда присутствует как минимум один элемент "Ваш выбор".
                 */
                show = selectedList.children.length > 1
            }

            if (show) {
                selectedList.style.display = ''

            } else {
                selectedList.style.display = 'none'
            }
        })
        this.updateVisibilityDeleteButton(show)
    }

    /**
     * Скрывает/показывает кнопку сброса фильтра.
     */
    static updateVisibilityDeleteButton(show) {
        let allDeleteButtons = document.querySelectorAll('.filter__button_delete')

        allDeleteButtons.forEach(function (deleteButton) {
            if (show) {
                deleteButton.style.display = ''
            } else {
                deleteButton.style.display = 'none'
            }
        })
    }

    /**
     * Обработка события клика по кнопке отмены фильтра.
     * @param cancelFilterElement
     */
    static cancelFilter(cancelFilterElement) {
        let jsonData = cancelFilterElement.dataset.json
        let json = JSON.parse(jsonData)
        if (!json) {
            return
        }

        cancelFilterElement.remove()

        json.forEach(id => {
            let element = document.getElementById(id)
            if (element) {
                switch (element.type) {
                    case 'text':
                        element.value = ''
                        element.onkeyup(undefined)
                        break
                    case 'checkbox':
                        element.click()
                        break
                    case 'radio':
                        element.click()
                        break
                }
            }
        })

        /**
         * Удаляет копии фильтра
         */
        let allFilter = document.querySelectorAll('.filter__selected[data-json]')
        allFilter.forEach(function (filter) {
            if (filter.dataset.json === jsonData) {
                filter.remove()
            }
        })

        /**
         * Скрывает/показывает filter__selected-list в зависимости от наличия выбранных значений
         */
        this.updateVisibilitySelectedList()
    }


    static keyup(element) {
        element.setAttribute('value', element.value)
        smartFilter.keyup(element)
    }

    static click(element) {
        if (element.checked) {
            element.setAttribute('checked', '')
        } else {
            element.removeAttribute('checked')
        }
        smartFilter.click(element)
    }

    /**
     * Показывает в фильтре общее количество найденных товаров
     * @param totalCount
     */
    static showTotalCount(totalCount) {
        let count = this.filterCountMessage.replace('#ELEMENT_COUNT#', totalCount)
        document.querySelectorAll('.filter__button_show-products').forEach(function (element) {
            element.value = count
        })
    }
}

window.ProductFilter = ProductFilter;